import styled from "styled-components";
import moment from "moment";

const Menu = ({ menu, usuario, reservar, cancelar }) => {
  const yaReservo = menu.pedidos.find((a) => a.cliente.id === usuario.id);

  const boton = yaReservo ? (
    <button type="button" className="cancelar" onClick={() => cancelar(menu)}>
      Cancelar
    </button>
  ) : (
    <button type="button" className="reservar" onClick={() => reservar(menu)}>
      Reservar
    </button>
  );

  return (
    <Card key={menu.id}>
      <CardHeader>
        <p>{moment(menu.fecha).format("dddd, D MMMM YYYY")}</p>
      </CardHeader>
      <CardContent>
        <img src={menu.plato.imagenUrl} alt={menu.nombre} />
        <h4>{menu.plato.nombre}</h4>
        <p className="precio">LPS {menu.plato.precio}</p>
        <p className="descripcion">{menu.plato.descripcion}</p>

        {boton}
      </CardContent>
    </Card>
  );
};

const Card = styled.div`
  width: 100%;
  padding: 1rem;
  margin-bottom: 30px;
  -webkit-border-radius: 10px;
  border-radius: 10px;
  background: #f2f2f2;
  -webkit-box-shadow: 12px 12px 24px #c9cbd0, -12px -12px 24px #ffffff;
  box-shadow: 12px 12px 24px #c9cbd0, -12px -12px 24px #ffffff;
`;

const CardHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid;
  margin-bottom: 10px;

  p {
    text-transform: capitalize;
  }
`;

const CardContent = styled.div`
  margin-bottom: 10px;
  img {
    width: 100%;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .precio {
    margin-top: 5px;
    margin-bottom: 10px;
    font-weight: 500;
    font-size: 20px;
  }
  .descripcion {
    text-align: justify;
    margin-top: 10px;
    font-size: 12px;
    height: 5rem;
    max-height: 5rem;
    overflow-y: scroll;
  }

  .reservar {
    width: 100%;
    height: 2rem;
    margin-bottom: 5px;
    border: none;
    border-radius: 5px;
    outline: none;
    transition: all 0.5s ease;
    color: #fff;
    background: #034001;
    &:hover {
      cursor: pointer;
      background: #055902;
    }
  }

  .cancelar {
    width: 100%;
    height: 2rem;
    margin-bottom: 5px;
    border: none;
    border-radius: 5px;
    outline: none;
    transition: all 0.5s ease;
    color: #fff;
    background: #f28705;
    &:hover {
      cursor: pointer;
      background: #f2a922;
    }
  }
`;

export default Menu;
